export default __webpack_public_path__ + "static/media/gallery5.147d38e6.jpg";